import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const getI18nPrefix = enabled => enabled ? 'enabled' : 'disabled';
const i18nKey = key => `ContentComponents.cmv2.fields.form.marketingContactsWarning.${key}`;
const MarketingContactsWarning = ({
  enabled = false,
  useEditor = false,
  openFormFn = () => {}
}) => {
  const type = enabled ? 'success' : 'warning';
  return /*#__PURE__*/_jsx(Alert, {
    type: type,
    "data-is-enabled": enabled,
    marginBlockEnd: "400",
    children: useEditor ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey(`${getI18nPrefix(enabled)}.goToEditor_jsx`),
      options: {
        external: true,
        onClick: openFormFn
      },
      elements: {
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: i18nKey(`${getI18nPrefix(enabled)}.editInline`)
    })
  });
};
export default MarketingContactsWarning;